import React from "react";

const HeroBooking = () => {
  return (
    <section className="hero-booking">
      <div className="hero-container">
        <div className="hero-text">
          <h1 className="hero-title">Reservations</h1>
          <p className="hero-content">
            We can’t wait to host you. If you have any special requirements
            please feel free to call on the phone number below. We’ll be happy
            to accommodate you.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroBooking;
